import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import "react-medium-image-zoom/dist/styles.css";
import { checkLoggedIn } from "../../utils";
import { useLoginModal } from "../../Context/LoginModalContext";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Avatar, Box, Rating, Skeleton } from "@mui/material";
import countryCodes from "./allthecountrydata.json";
import MobileInput from "./InputMobile";
import { MoonLoader } from "react-spinners";
import ShowPlanes from "./showPlanes";
import { toast } from "react-toastify";
import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import RechargePaymentModal from "./RechargePaymentModal";

const Product = ({ token, carts, w_list, addToCart, addToCartProduct, removeFromCart, incrementQuantity, decrementQuantity, ...props }) => {
  const { slug } = useParams();

  const navigate = useNavigate();
  const { openLoginModal } = useLoginModal();
  const [MobileNo, setMobileNO] = useState({ dialCode: "", phoneValue: "" });
  const [openRechargeModal, setOpenRechargeModal] = React.useState(false);

  const [singleProduct, setSingleProduct] = useState(null);
  const [showPlans, setShowPlans] = useState("bundel");
  const [selectedRecharge, setSelectedRecharge] = useState({ recharge: "", type: "" });

  const [loading, setLoading] = useState(false);

  const [Airtimeloading, setAirtimeLoading] = useState(false);
  const [AirtimeData, setAirtimeData] = useState([]);
console.log({ AirtimeData });
  const [error, setError] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);

  const inCart = useMemo(() => {
    return carts.find((cart) => cart.id === singleProduct?.id);
  }, [carts, singleProduct]);

  const inWishList = useMemo(() => {
    return w_list?.find((wish) => wish.id === singleProduct?.id);
  }, [w_list, singleProduct]);

  const getSingleProductData = async () => {
    setLoading(true);
    if (error) setError(false);
    await axios
      .get("sim/get-country-provider", {
        params: { slug },
      })
      .then((res) => {
        let singleProduct = {
          ...res?.data?.data?.[0],
        };
        setSingleProduct(singleProduct);

        getAirtimeData(singleProduct);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
      });
  };
  const getAirtimeData = async (datas) => {
    setAirtimeLoading(true);

    await axios
      .get("sim/get-plans", {
        params: {
          ios_code: datas?.ios_code,
          operator_id: datas?.operator_id,
          service_id: 1,
          subservice_id: 13,
        },
      })
      .then((res) => {
        const filteredData = res.data.plans.filter((item) => item.data.length > 0);
        setAirtimeData(filteredData);
        for (const item of res.data.plans) {
          if (item.data && item.data.length > 0) {
            setShowPlans(item.type);
            setSelectedRecharge({ recharge: item.data[0], type: item.type });
            break;
          }
        }

        setAirtimeLoading(false);
      })
      .catch((err) => {
        setAirtimeLoading(false);
      });
  };
  useEffect(() => {
    getSingleProductData();
  }, []);

  function handleClick(event) {
    // event.preventDefault();
    navigate(event);
    console.info("You clicked a breadcrumb.");
  }
  const breadcrumbs = [
    <Link underline="hover" key="1" color="white" onClick={() => handleClick("/shop")}>
      Shop
    </Link>,
    <Link underline="hover" key="2" color="white" onClick={() => handleClick("/shop")}>
      Categories
    </Link>,
    <Typography key="3" sx={{ color: "text.white" }}>
      Mobile recharges
    </Typography>,
  ];

  function getFlagIconFromISO3(iso3Code) {
    const match = countryCodes.find((country) => country?.iso_code === iso3Code?.toUpperCase());
    return match ? match?.flag_icon.toLowerCase() : "ae"; // default to 'ae'
  }

  const FlagImage = ({ iso3 }) => {
    const iso2 = getFlagIconFromISO3(iso3);

    return (
      <img
        src={`https://flagcdn.com/h24/${iso2}.png`}
        srcSet={`
          https://flagcdn.com/h48/${iso2}.png 2x`}
        height="24"
        alt={`Flag of ${iso2.toUpperCase()}`}
      />
    );
  };

  const handelSelectedRecharge = async (recharge, type) => {
    setSelectedRecharge({ recharge, type });
  };
  const BuyNowRecharge = async () => {
    if (selectedRecharge.recharge === "") {
      toast.error("Please select the recharge");
      return;
    }
    if (!MobileNo.phoneValue) {
      toast.error("Please enter the mobile number");
      return;
    }
    const isValid = isValidPhoneNumber("+" + MobileNo.phoneValue);

    if (!isValid) {
      toast.error("Please enter a valid mobile number");
      return;
    }
    if (checkLoggedIn()) {
      setOpenRechargeModal((prv) => !prv);
    } else {
      openLoginModal();
    }
  };
  const skeletonItems = Array.from({ length: 16 });
  return (
    <div className="product-details single-product">
      <div className="operator-mobile-recharge-main">
        <Stack spacing={2} color={"white"}>
          <Breadcrumbs color={"white"} separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs}
          </Breadcrumbs>
        </Stack>
        <div className="operator-mobile-recharge-main-flex">
          <div>
            <div className="operator-first-img-section">
              <div>
                <img src={singleProduct?.operator_image} alt={singleProduct?.operator_title} />
              </div>
              <div className="operator-details-section">
                <div>
                  <h4>{singleProduct?.operator_title}</h4>
                  <div className="rating-div">
                    <div>
                      {" "}
                      <Rating
                        sx={{
                          "& .MuiRating-iconEmpty": {
                            color: "grey",
                          },
                        }}
                        name="size-small"
                        defaultValue={2}
                        size="small"
                        readOnly
                      />
                    </div>
                    <div>
                      <p>3/5</p>
                    </div>
                  </div>
                  <div className="flag-main-div">
                    <div>
                      <FlagImage iso3={singleProduct?.ios_code} />
                    </div>
                    <div>
                      <p>{singleProduct?.operator_country}</p>
                      <p>{singleProduct?.operator_description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {!Airtimeloading ? (
                <>
                  <div className="tab-btn-main-div" style={AirtimeData?.length < 3 ? { width: "40%" } : { width: "60%" }}>
                    {AirtimeData?.map(
                      (plan) =>
                        plan?.data &&
                        plan?.data.length > 0 && (
                          <button key={plan?.type} className={showPlans === plan.type ? "tab-btn-active" : ""} onClick={() => setShowPlans(plan.type)}>
                            {plan.type.charAt(0).toUpperCase() + plan.type.slice(1)}
                          </button>
                        )
                    )}
                  </div>

                  <div>
                    {AirtimeData?.map(
                      (plan) =>
                        plan?.data &&
                        plan?.data.length > 0 && (
                          <div key={plan?.type}>
                            {showPlans === plan?.type && (
                              <ShowPlanes
                                selectedRecharge={selectedRecharge}
                                type={plan?.type}
                                data={plan?.data}
                                handelSelectedRecharge={handelSelectedRecharge}
                                Image={singleProduct?.operator_image}
                                title={singleProduct?.operator_title}
                              />
                            )}
                          </div>
                        )
                    )}
                    {/* {showPlans === "bundle" && <ShowPlanes type="bundel" />}
              {showPlans === "data" && <ShowPlanes type="data" />}
              {showPlans === "airtime" && <ShowPlanes type="airtime" />} */}
                  </div>
                </>
              ) : (
                <div className="mt-50 ml-50">
                  <MoonLoader size={46} color="#13d3c3" />

                  <Box
                    sx={{
                      mt: "50px",
                      bgcolor: "transparent",
                      pr: 8,
                      width: "100%",
                      display: "flex",
                      justifyContent: "left",
                      flexWrap: "wrap", // optional: allow wrapping on smaller screens
                      gap: "50px",
                    }}
                  >
                    {skeletonItems.map((_, idx) => (
                      <Skeleton key={idx} sx={{ bgcolor: "grey.900" }} variant="rectangular" width={210} height={118} />
                    ))}
                  </Box>
                </div>
              )}
            </div>
          </div>
          <div className="mobile-recharge-no-div-main">
            <p>Mobile number for recharge*</p>
            <MobileInput MobileNo={MobileNo} setMobileNO={setMobileNO} iso3Code={singleProduct?.ios_code} />

            <p>
              {" "}
              <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />{" "}
              {Airtimeloading ? <MoonLoader size={16} color="#13d3c3" /> : selectedRecharge?.recharge?.prices?.retail?.amount}
            </p>

            <button disabled={Airtimeloading} onClick={BuyNowRecharge}>
              Buy Now
            </button>
          </div>
        </div>
      </div>

      <RechargePaymentModal
        Image={singleProduct?.operator_image}
        title={singleProduct?.operator_title}
        selectedRecharge={selectedRecharge}
        openRechargeModal={openRechargeModal}
        setOpenRechargeModal={setOpenRechargeModal}
      />
    </div>
  );
};

export default Product;
